module.exports = __webpack_public_path__ + "static/img/3.99e1bfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/hsyl/hsyj/3.png
// module id = /g9T
// module chunks = 1